import { antGrey } from '@/components/styles/globalStyles';
import React from 'react';

export const commonInputFieldStyle: React.CSSProperties = {
    maxWidth: 1400,
    width: '90%',
    minWidth: 300,
};

export const commonLabelStyle: React.CSSProperties = {
    fontWeight: 600,
    fontSize: 14,
    color: antGrey.grey8,
};
